import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	cardCountLabel: {
		id: 'company-hub.cards-extension.link-cards-content.card-components.card-count-label',
		defaultMessage: 'Number of cards',
		description:
			'Label for the card count input field. This field allows users to specify the number of dynamic cards to display within the Editor',
	},
	viewCurrentFilters: {
		id: 'company-hub.cards-extension.link-cards-content.card-components.view-current-filters',
		defaultMessage: 'View current filters',
		description:
			'Action button message for building dynamic cards, when clicked, shows a modal to build dynamic cards with existing filters',
	},
});
